export default __webpack_public_path__ + "static/media/Asset1.78859902.svg";